// v1 knowledge facts, discrepancies and «Preguntas por resolver». Schemas in api-knowledge-facts.ts.
import * as K from './api-knowledge-facts.js';
import { IdParam, items, route, W } from './route-def.js';

const P = W({ projectId: IdParam });

export const knowledgeFactRoutes = {
  listKnowledgeFacts: route({
    method: 'GET', path: '/workspaces/:workspaceId/projects/:projectId/facts', summary: 'Datos del proyecto con fuente, fecha y vigencia', tag: 'knowledge',
    minRole: 'advisor', params: P, response: items(K.KnowledgeFactSchema),
  }),
  createKnowledgeFact: route({
    method: 'POST', path: '/workspaces/:workspaceId/projects/:projectId/facts', summary: 'Registrar un dato con su fuente (detecta discrepancias)', tag: 'knowledge',
    minRole: 'manager', params: P, body: K.CreateKnowledgeFactSchema, response: K.KnowledgeFactSchema, status: 201,
  }),
  listKnowledgeDiscrepancies: route({
    method: 'GET', path: '/workspaces/:workspaceId/projects/:projectId/discrepancies', summary: 'Discrepancias entre fuentes', tag: 'knowledge',
    minRole: 'advisor', params: P, query: K.DiscrepancyListQuerySchema, response: items(K.KnowledgeDiscrepancySchema),
  }),
  resolveKnowledgeDiscrepancy: route({
    method: 'POST', path: '/workspaces/:workspaceId/discrepancies/:discrepancyId/resolve', summary: 'Elegir el valor correcto de una discrepancia', tag: 'knowledge',
    minRole: 'manager', params: W({ discrepancyId: IdParam }), body: K.ResolveDiscrepancySchema, response: K.KnowledgeDiscrepancySchema,
  }),
  listPendingQuestions: route({
    method: 'GET', path: '/workspaces/:workspaceId/projects/:projectId/pending-questions', summary: 'Preguntas por resolver (agrupadas)', tag: 'knowledge',
    minRole: 'advisor', params: P, query: K.PendingQuestionListQuerySchema, response: items(K.PendingQuestionSchema),
  }),
  answerPendingQuestion: route({
    method: 'POST', path: '/workspaces/:workspaceId/pending-questions/:questionId/answer', summary: 'Responder: «Solo este caso» o «Guardar en la base del proyecto»', tag: 'knowledge',
    minRole: 'manager', params: W({ questionId: IdParam }), body: K.AnswerPendingQuestionSchema, response: K.PendingQuestionSchema,
  }),
};
